/* @flow */

import React from 'react';
import { Select, withStyles } from '@material-ui/core';
import InvoiceCompanyName from '../layouts/Member/components/InvoiceCompanyName';
import InoviceDataPoints from '../layouts/Member/components/InoviceDataPoints';
import InvoiceBankAccount from '../layouts/Member/components/InvoiceBankAccount';
import InvoiceDialogTable from '../layouts/Member/components/InvoiceDialogTable';
import InvoiceDisclaimer from '../layouts/Member/components/InvoiceDisclaimer';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import FilterIcon from '@material-ui/icons/FilterList';
import SearchIcon from '@material-ui/icons/Search';
import ViewInvoice from './ViewInvoice';
import InvoiceDownload from '../layouts/Admin/components/InvoiceDownload';
import MemberProfilesExport from '../layouts/Admin/components/MemberProfilesExport';
import MemberSubmissionsExport from '../layouts/Admin/components/MemberSubmissionsExport';
import MemberSubmittedDataExport from '../layouts/Admin/components/MemberSubmittedDataExport';
import { ClassNameMap } from '@material-ui/styles/withStyles';

const styles = theme => ({
    paper: {
        margin: 'auto',
        padding: '10px',
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        backgroundColor: theme.palette.background.paper,
    },
    gridItem: {
        margin: '10px',
    }
});

type Props = {|
    classes: ClassNameMap
        |};

type State = {|
    results: Array < InvoiceSearchResult >,
        selectedCompanyId: number,
            selectedInvoiceId: number,
                selectedCreatedDate: any,
                    selectedDueDate: any,
                        year: any,
                            customerPoNumber: string
                                |}

class AdminReporting extends React.Component<Props, State> {
    state: State = {
        invoiceResults: [],
        selectedCompanyId: 0,
        selectedInvoiceId: 0,
        selectedCreatedDate: '',
        selectedDueDate: '',
        year: '',
        customerPoNumber: null
    };

    render() {
        const { classes } = this.props;
        const { selectedCompanyId, selectedInvoiceId, selectedDueDate, selectedCreatedDate, year, customerPoNumber, invoiceResults } = this.state;

        return (<div>
            <Grid container direction='row' spacing={1}>
                <Grid item xs={5} className={classes.gridItem}>
                    <Typography variant='h5' component='h3' color='secondary'>
                        Download Invoices By Year
                    </Typography>
                    <InvoiceDownload/>
                </Grid>
                <Grid item xs={5} className={classes.gridItem}>
                    <Typography variant='h5' component='h3' color='secondary'>
                        Export Member Profiles
                    </Typography>
                    <Paper className={classes.paper}>
                        <MemberProfilesExport/>
                    </Paper>
                </Grid>
                <Grid item xs={5} className={classes.gridItem}>
                    <Typography variant='h5' component='h3' color='secondary'>
                        Export Member Submission Statuses
                    </Typography>
                    <Paper className={classes.paper}>
                        <MemberSubmissionsExport />
                    </Paper>
                </Grid>
                <Grid item xs={5} className={classes.gridItem}>
                    <Typography variant='h5' component='h3' color='secondary'>
                        Export Member Submitted Data
                    </Typography>
                    <Paper className={classes.paper}>
                        <MemberSubmittedDataExport />
                    </Paper>
                </Grid>
            </Grid>
        </div>);

    }
}

export default (withStyles(styles)(AdminReporting));
